import { Rule } from "antd/lib/form"
import moment from "moment-timezone"
import { i18n } from "~Shared/locales/i18n"

export const createBankMatchingRules = (dateFilter?: any) => ({
    startDate: [
        { type: "date", required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: moment.Moment) => {
                if (dateFilter?.endDate && value) {
                    if (value.toDate() > dateFilter?.endDate) {
                        return Promise.reject(
                            i18n.t("validation:date_before", {
                                attribute: i18n.t("input:expense_filter.starting_date"),
                                compare: i18n.t("input:expense_filter.ending_date"),
                            }),
                        )
                    }
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
    endDate: [
        { type: "date", required: true, message: i18n.t("validation:required") },
        {
            validator: (_rule, value: moment.Moment) => {
                if (dateFilter?.startDate && value) {
                    if (value.toDate() < dateFilter?.startDate) {
                        return Promise.reject(
                            i18n.t("validation:date_after", {
                                attribute: i18n.t("input:expense_filter.ending_date"),
                                compare: i18n.t("input:expense_filter.starting_date"),
                            }),
                        )
                    }
                }

                return Promise.resolve()
            },
        },
    ] as Array<Rule>,
})
